import React, { useEffect, useState } from "react";
import { apiPut, Get_Api } from "../ApiUrls";
import { toast } from "react-toastify";

function UpdatePersonalDetailModal({ show, onClose, GetHostessProfile, HostessProfile }) {
    const [Country, setCountry] = useState(HostessProfile?.Country || "");
    const [State, setState] = useState(HostessProfile?.State || "");
    const [City, setCity] = useState(HostessProfile?.City || "");
    const [IsUploading, setIsUploading] = useState(false);
    const [AllCountry, setAllCountry] = useState([]);
    const [allStateCity, setAllStateCity] = useState([]);
    const [cities, setCities] = useState([]);


    useEffect(() => {
        if (HostessProfile) {
            setCountry(HostessProfile?.Country || "");
            setState(HostessProfile?.State || "");
            setCity(HostessProfile?.City || "");
        }
    }, [HostessProfile]);

    useEffect(() => {
        GetAllCountries();
    }, []);

    useEffect(() => {
        if (Country) {
            getAllStateCity();
        } else {
            setAllStateCity([]);
            setState("");
            setCity("");
            setCities([]);
        }
    }, [Country]);

    useEffect(() => {
        if (State) {
            const selectedState = allStateCity.find((state) => state.Title === State);
            setCities(selectedState?.City || []);
        } else {
            setCities([]);
            setCity("");
        }
    }, [State, allStateCity]);

    const GetAllCountries = async () => {
        try {
            const response = await Get_Api("api/admin/GetAllCountry");
            setAllCountry(response?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to fetch countries.");
        }
    };

    const getAllStateCity = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api(`api/admin/GetAllStateCity?country=${Country}`);
            setAllStateCity(response?.data || []);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            toast.error("Failed to fetch states and cities.");
        }
    };

    const handleUpdateHostess = async () => {
        if (!Country) {
            toast.error("Country is required!");
            return;
        }
        if (!State) {
            toast.error("State is required!");
            return;
        }
        if (!City) {
            toast.error("City is required!");
            return;
        }

        try {
            setIsUploading(true);
            let data = { Country, State, City };
            await apiPut("api/hostess/UpdateHostess", data);
            toast.success("Personal details updated successfully!");
            localStorage.setItem('Country', Country || "India");
            GetHostessProfile();
            onClose();
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to update details.");
        } finally {
            setIsUploading(false);
        }
    };

    if (!show) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h2>Update Personal Details</h2>
                <div className="about-input">
                    <label>Country</label>
                    <select value={Country} onChange={(e) => setCountry(e.target.value)}>
                        <option value="" disabled>Select Country</option>
                        {AllCountry.map((country, index) => (
                            <option key={index} value={country?.Title}>{country?.Title}</option>
                        ))}
                    </select>
                </div>

                <div className="about-input">
                    <label>State</label>
                    <select value={State} onChange={(e) => setState(e.target.value)} disabled={!Country}>
                        <option value="" disabled>Select State</option>
                        {allStateCity.map((state, index) => (
                            <option key={index} value={state?.Title}>{state?.Title}</option>
                        ))}
                    </select>
                </div>

                <div className="about-input">
                    <label>City</label>
                    <select value={City} onChange={(e) => setCity(e.target.value)} disabled={!State}>
                        <option value="" disabled>Select City</option>
                        {cities.map((city, index) => (
                            <option key={index} value={city}>{city}</option>
                        ))}
                    </select>
                </div>

                <div className='center' style={{ gap: 20 }}>
                    <button onClick={onClose} className="cancel-btn">Cancel</button>
                    <button onClick={handleUpdateHostess} className="save-btn">
                        {IsUploading ? "Updating..." : "Save"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UpdatePersonalDetailModal;
